import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Twitter } from "lucide-react";
import { navLinks, siteInfo } from "../mock";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer className="bg-neutral-950 text-neutral-200">
      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo variant="light" />
          <p className="mt-4 text-teal-400 text-sm font-semibold tracking-wide">{siteInfo.tagline}</p>
          <div className="mt-5 flex items-center gap-4 text-neutral-400">
            <a href="#" aria-label="Instagram" className="hover:text-teal-500 transition-colors"><Instagram className="w-5 h-5" /></a>
            <a href="#" aria-label="Twitter" className="hover:text-teal-500 transition-colors"><Twitter className="w-5 h-5" /></a>
            <a href="#" aria-label="LinkedIn" className="hover:text-teal-500 transition-colors"><Linkedin className="w-5 h-5" /></a>
          </div>
        </div>

        <div>
          <h4 className="text-lg font-semibold">Quick Links</h4>
          <ul className="mt-4 space-y-2 text-neutral-300">
            {navLinks.map((l) => (
              <li key={l.name}>
                <Link to={l.path} className="hover:text-teal-500 transition-colors capitalize">
                  {l.name.toLowerCase().replace("us", "Us")}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-lg font-semibold">Contact</h4>
          <address className="not-italic mt-4 text-sm leading-7 text-neutral-300">
            <div className="font-semibold text-white">{siteInfo.address.line1}</div>
            <div>{siteInfo.address.line2}</div>
            <div>{siteInfo.address.line3}</div>
            <div>{siteInfo.address.line4}</div>
            <div>{siteInfo.address.line5}</div>
          </address>
          <p className="mt-4 text-sm">
            Email: <a href={`mailto:${siteInfo.email}`} className="underline text-teal-400">{siteInfo.email}</a>
          </p>
        </div>
      </div>
      <div className="border-t border-neutral-800">
        <div className="max-w-7xl mx-auto px-6 py-5 text-center text-sm text-neutral-500">
          © 2025 All rights reserved by ASTORIA SOLUTIONS
        </div>
      </div>
    </footer>
  );
};

export default Footer;
